import React from 'react'

export default function NavMarkers(props) {
  return (
    <div
      className="sub-nav-item"
      {...props}
    />
  )
}
